import { useQuery } from "@tanstack/react-query";

type BetaInviteInfo = {
  name: string;
};

async function validateBetaInvite(code: string): Promise<BetaInviteInfo> {
  const baseUrl = process.env.EXPO_PUBLIC_API_BASE_URL;
  const res = await fetch(`${baseUrl}/beta-invites/validate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });

  if (!res.ok) {
    if (res.status === 400 || res.status === 404) {
      throw new Error("This invite link is no longer valid.");
    }
    throw new Error("Something went wrong. Please try again.");
  }

  const json = await res.json();
  return json.data;
}

export function useBetaInviteValidation(code: string | undefined) {
  const query = useQuery({
    queryKey: ["beta-invite", code],
    queryFn: () => validateBetaInvite(code!),
    enabled: !!code,
    retry: false,
    staleTime: Infinity,
  });

  return {
    inviteInfo: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error?.message ?? null,
  };
}
